import React, { useState } from 'react';
import { Box, Container, Typography, TextField, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { createNews } from '../api/news';

const NewsForm = () => {
    const navigate = useNavigate();
    const [news, setNews] = useState({
        title: '',
        content: '',
        image: null
    });
    const [imagePreview, setImagePreview] = useState(null);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setNews({ ...news, image: file });
        setImagePreview(URL.createObjectURL(file));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('title', news.title);
        formData.append('content', news.content);
        if (news.image) {
            formData.append('image', news.image);
        }

        try {
            await createNews(formData);
            navigate('/admin/news');
        } catch (error) {
            console.error('Error creating news:', error);
        }
    };

    return (
        <Container maxWidth="md">
            <Box sx={{ mt: 4, mb: 4 }}>
                <Typography variant="h4" gutterBottom>
                    Create News Article
                </Typography>
                <Paper sx={{ p: 3 }}>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Title"
                            margin="normal"
                            required
                            value={news.title}
                            onChange={(e) => setNews({ ...news, title: e.target.value })}
                        />
                        <TextField
                            fullWidth
                            label="Content"
                            margin="normal"
                            required
                            multiline
                            rows={6}
                            value={news.content}
                            onChange={(e) => setNews({ ...news, content: e.target.value })}
                        />
                        <Box sx={{ mt: 2, mb: 2 }}>
                            <input
                                accept="image/*"
                                type="file"
                                onChange={handleImageChange}
                                style={{ display: 'none' }}
                                id="news-image-upload"
                            />
                            <label htmlFor="news-image-upload">
                                <Button variant="contained" component="span">
                                    Upload Cover Image
                                </Button>
                            </label>
                        </Box>
                        {imagePreview && (
                            <Box sx={{ mt: 2, mb: 2 }}>
                                <img 
                                    src={imagePreview} 
                                    alt="Preview" 
                                    style={{ maxWidth: '100%', maxHeight: 300 }} 
                                />
                            </Box>
                        )}
                        <Box sx={{ mt: 3 }}>
                            <Button 
                                type="submit" 
                                variant="contained" 
                                color="primary" 
                                size="large"
                            >
                                Publish News
                            </Button>
                        </Box>
                    </form>
                </Paper>
            </Box>
        </Container>
    );
};

export default NewsForm;
